module.exports = __webpack_public_path__ + "img/企业荣誉.3e21e208.png";